/*
  easyback cart drawer helpers (loaded with defer from snippets/eb-cart-drawer-main.liquid).
  - Section Rendering fix: the drawer is a section of the footer group, and the Section Rendering API
    only returns its saved settings under the long group id (sections--N__cart-drawer). The theme asks
    for "cart-drawer", so requests are rewritten to the real id and the answer is mapped back.
  - Hides the sticky add-to-cart bar while the drawer is open (html.eb-cart-open).
  - <eb-delivery-date>: "order today, estimated arrival <date>", counted in
    Israeli business days (Sun-Thu), skipping Fri/Sat and the dates in data-skip.
  - <eb-upsell>: add-on carousel (prev/next + Add to cart).
  - <eb-line-variant>: swap a cart line to another variant.
  Custom elements, so they work again every time the theme re-renders the drawer.
*/
(function () {
  if (window.ebCartDrawer) return;
  window.ebCartDrawer = true;

  var origFetch = window.fetch;
  function realId() {
    var el = document.querySelector('[id^="shopify-section-sections--"][id$="__cart-drawer"]');
    return el ? el.id.slice(16) : null;
  }
  if (origFetch) {
    window.fetch = function (input, init) {
      var id = realId();
      if (!id) return origFetch.apply(this, arguments);
      var changed = false;
      var fix = function (v) {
        if (Array.isArray(v)) {
          return v.map(function (x) { if (x === 'cart-drawer') { changed = true; return id; } return x; });
        }
        if (typeof v === 'string' && v.split(',').indexOf('cart-drawer') > -1) {
          changed = true;
          return v.split(',').map(function (x) { return x === 'cart-drawer' ? id : x; }).join(',');
        }
        return v;
      };
      try {
        if (typeof input === 'string' && /[?&]sections?(_id)?=/.test(input)) {
          input = input.replace(/([?&]sections?(?:_id)?=)([^&]*)/, function (m, p, val) {
            return p + encodeURIComponent(fix(decodeURIComponent(val)));
          });
        }
        if (init && typeof init.body === 'string' && init.body.indexOf('cart-drawer') > -1) {
          var b = JSON.parse(init.body);
          if (b.sections) {
            b.sections = fix(b.sections);
            init = Object.assign({}, init, { body: JSON.stringify(b) });
          }
        } else if (init && window.FormData && init.body instanceof FormData && init.body.has('sections')) {
          init.body.set('sections', fix(init.body.get('sections')));
        }
      } catch (e) { changed = false; }
      var p = origFetch.call(this, input, init);
      if (!changed) return p;
      return p.then(function (res) {
        return res.clone().text().then(function (t) {
          if (t.indexOf(id) === -1) return res;
          try {
            var j = JSON.parse(t);
            if (j.sections && j.sections[id] !== undefined) {
              j.sections['cart-drawer'] = j.sections[id];
              delete j.sections[id];
            }
            return new Response(JSON.stringify(j), { status: res.status, statusText: res.statusText, headers: res.headers });
          } catch (e) { return res; }
        });
      });
    };
  }

  // Sticky add-to-cart bar steps aside while the drawer is open.
  (function () {
    var st = document.createElement('style');
    st.textContent = 'html.eb-cart-open .ebs{transform:translateY(110%)!important;visibility:hidden!important;pointer-events:none}html.eb-cart-open .eb-a11y-btn{bottom:12px!important}';
    document.head.appendChild(st);
    function watch() {
      var d = document.querySelector('cart-drawer');
      if (!d || d._ebWatch) return;
      d._ebWatch = true;
      var sync = function () { document.documentElement.classList.toggle('eb-cart-open', d.classList.contains('active')); };
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
    watch();
    document.addEventListener('DOMContentLoaded', watch);
  })();

  var DAYS = ['יום א׳', 'יום ב׳', 'יום ג׳', 'יום ד׳', 'יום ה׳', 'יום ו׳', 'שבת'];

  function nowInIsrael() {
    var o = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), hour: +o.hour };
  }

  function iso(d) { return d.toISOString().slice(0, 10); }

  function arrivalDate(days, cutoff, skip) {
    var now = nowInIsrael();
    var d = now.date;
    var isBiz = function (x) { var w = x.getUTCDay(); return w !== 5 && w !== 6 && skip.indexOf(iso(x)) === -1; };
    // Ordered after the cutoff hour, or on a non business day: the count starts a day later.
    var left = days + (isBiz(d) && now.hour >= cutoff ? 1 : 0);
    while (left > 0) {
      d = new Date(d.getTime() + 864e5);
      if (isBiz(d)) left--;
    }
    return d;
  }

  if (!customElements.get('eb-delivery-date')) {
    customElements.define('eb-delivery-date', class extends HTMLElement {
      connectedCallback() {
        var out = this.querySelector('[data-date]');
        if (!out) return;
        var skip = (this.dataset.skip || '').split(',').map(function (s) { return s.trim(); });
        var d = arrivalDate(parseInt(this.dataset.days, 10) || 7, parseInt(this.dataset.cutoff, 10) || 24, skip);
        out.textContent = DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + '.' + (d.getUTCMonth() + 1);
        this.removeAttribute('hidden');
      }
    });
  }

  function cartUrl(name) {
    var r = window.routes || {};
    return (r[name] || '/cart/' + name.replace('cart_', '').replace('_url', '')) + '.js';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Adds items and re-renders the drawer the same way the theme does after Add to cart.
  function addAndRender(items) {
    return post(cartUrl('cart_add_url'), {
      items: items,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'error');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.renderContents) drawer.renderContents(res);
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return res;
    });
  }

  if (!customElements.get('eb-upsell')) {
    customElements.define('eb-upsell', class extends HTMLElement {
      connectedCallback() {
        var track = this.querySelector('[data-track]');
        if (!track) return;
        var step = function (dir) {
          // RTL: "next" moves toward the left.
          var rtl = getComputedStyle(track).direction === 'rtl';
          track.scrollBy({ left: dir * (rtl ? -1 : 1) * track.clientWidth, behavior: 'smooth' });
        };
        this.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
        this.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });

        this.addEventListener('change', function (e) {
          var sel = e.target.closest('[data-variant-select]');
          if (!sel) return;
          // Keep the theme's quantity handler (on cart-drawer-items) from reading this select.
          e.stopPropagation();
          var opt = sel.options[sel.selectedIndex];
          var card = sel.closest('[data-card]');
          var price = card.querySelector('[data-price]');
          var was = card.querySelector('[data-was]');
          if (price && opt.dataset.price) price.textContent = opt.dataset.price;
          if (was) { was.textContent = opt.dataset.was || ''; was.hidden = !opt.dataset.was; }
        });

        this.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-add]');
          if (!btn || btn.disabled) return;
          var card = btn.closest('[data-card]');
          var sel = card.querySelector('[data-variant-select]');
          var id = sel ? sel.value : btn.dataset.variantId;
          var err = card.querySelector('[data-error]');
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          addAndRender([{ id: Number(id), quantity: 1 }]).catch(function (ex) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            if (err) { err.textContent = ex.message; err.hidden = false; }
          });
        });
      }
    });
  }

  if (!customElements.get('eb-line-variant')) {
    customElements.define('eb-line-variant', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('change', function (e) {
          var sel = e.target.closest('select');
          if (!sel) return;
          e.stopPropagation();
          if (sel.value === self.dataset.current) return;
          sel.disabled = true;
          var qty = parseInt(self.dataset.quantity, 10) || 1;
          post(cartUrl('cart_change_url'), { id: self.dataset.key, quantity: 0 })
            .then(function () { return addAndRender([{ id: Number(sel.value), quantity: qty }]); })
            .catch(function () { window.location.reload(); });
        });
      }
    });
  }

  // v3: pads subscription checkbox. Sets or clears the "מנוי רפידות" property on the kit line, then re-renders the drawer.
  if (!customElements.get('eb-sub-toggle')) {
    customElements.define('eb-sub-toggle', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('change', function (e) {
          var cb = e.target.closest('input[type="checkbox"]');
          if (!cb) return;
          // Keep the theme's quantity handler (on cart-drawer-items) from reading this checkbox.
          e.stopPropagation();
          self.classList.toggle('on', cb.checked);
          self.setAttribute('aria-busy', 'true');
          post(cartUrl('cart_change_url'), {
            id: self.dataset.key,
            quantity: parseInt(self.dataset.qty, 10) || 1,
            properties: { 'מנוי רפידות': cb.checked ? self.dataset.value : '' },
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          }).then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'error');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && drawer.renderContents) drawer.renderContents(res);
            else window.location.reload();
          }).catch(function (ex) {
            self.removeAttribute('aria-busy');
            cb.checked = !cb.checked;
            self.classList.toggle('on', cb.checked);
            var err = self.querySelector('[data-error]');
            if (err) { err.textContent = ex.message; err.hidden = false; }
          });
        });
      }
    });
  }

  // Exposed for the v3 product page: add to cart without leaving the page, then open the drawer.
  window.ebAddAndRender = addAndRender;

  // ?ebcart=1 opens the drawer on load (handy for sharing a preview link of the cart).
  if (/[?&]ebcart=1/.test(window.location.search)) {
    document.documentElement.classList.add('eb-preview-open');
    window.addEventListener('load', function () {
      setTimeout(function () { var d = document.querySelector('cart-drawer'); if (d && d.open) d.open(); }, 600);
    });
  }
})();
